var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('b-row',[_c('b-col',{staticClass:"mt-5",attrs:{"lg":"9"}},[_c('login-form')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }